module.exports = __webpack_public_path__ + "static/media/product_3.11485489.png";